var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("warning-step", {
        attrs: {
          title: "Hmm. Something went wrong.",
          description: "Please check your internet connection and try again.",
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "verification-method-selection__step__right-aligned-button-container",
        },
        [
          _c(
            "el-button",
            {
              staticClass: "account-verification__step__button",
              attrs: { type: "primary" },
              on: { click: _vm.requestRetry },
            },
            [_vm._v("\n      Try Again\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }